export const accommodationQueryKeys = {
  all: ["accommodations"] as const,
  list: (propertyTicker: string) => [...accommodationQueryKeys.all, propertyTicker] as const,
};
